import React from 'react';
import { useNavigate } from 'react-router-dom';
import './Team.css';
import teamData from '../data/team.json';
import { useContent } from '../contexts/ContentContext';

const Team = () => {
  const { getSection } = useContent();
  const data = getSection<typeof teamData>('team', teamData);
  const { batches } = data.teamMembers;
  const navigate = useNavigate();
  
  const handleViewAllMembers = (batchYear) => {
    // Navigate to the members page and scroll to the specific batch
    navigate(`/members#batch-${batchYear}`);
  };

  return (
    <section id="team" className="team-section">
      <div className="team-container">
        <div className="section-header">
          <h2 className="section-title">Our Amazing Team</h2>
          <p className="section-subtitle">
            Meet the talented individuals who make ASIMO Technical Club exceptional
          </p>
        </div>

        <div className="batches-grid">
          {batches.map((batch) => (
            <div key={batch.year} className="batch-card">
              <div className="batch-header">
                <div className="batch-icon">
                  <i className={batch.icon}></i>
                </div>
                <h3 className="batch-name">{batch.name}</h3>
                <div className="batch-year">{batch.year}</div>
              </div>
              
              <div className="batch-content">
                <p className="batch-description">{batch.description}</p>
              </div>
              
              <div className="batch-actions">
                <button 
                  className="btn-view-all-members"
                  onClick={() => handleViewAllMembers(batch.year)}
                >
                  View All Members
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Team;